import { render } from "./dialogueTypeTag.vue?vue&type=template&id=796e5f2e&scoped=true&ts=true&lang=pug"
import script from "./dialogueTypeTag.vue?vue&type=script&lang=ts"
export * from "./dialogueTypeTag.vue?vue&type=script&lang=ts"

import "./dialogueTypeTag.vue?vue&type=style&index=0&id=796e5f2e&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796e5f2e"]])

export default __exports__